import { createClient } from '@supabase/supabase-js';

// Configuration Supabase - utilise les variables d'environnement
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_KEY) {
  throw new Error('Variables d\'environnement Supabase manquantes (REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_ANON_KEY)');
}

// 🔐 Configuration de la persistance de session
export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
  auth: {
    // Activer la persistance de session dans le localStorage
    persistSession: true,
    
    // Stocker la session dans le localStorage (par défaut)
    storage: window.localStorage,
    
    // Détecter automatiquement le type de session (web)
    autoRefreshToken: true,
    
    // Détecter les changements de session
    detectSessionInUrl: true,
    
    // Configuration PKCE flow pour magic links
    flowType: 'pkce'
  }
}); 